@if (hasItems) {
  <!-- Expecting to see content, but getting noItemsMessage instead?  Did you use the [hkCarouselItem] directive when you added content to the carousel? -->
  <ng-content/>

  <ng-container *ngTemplateOutlet="scrollButton; context: { direction: 'REVERSE', visibilityProperty: showReverseButton }"/>
  <ng-container *ngTemplateOutlet="scrollButton; context: { direction: 'FORWARD', visibilityProperty: showForwardButton }"/>
} @else {
  <p class="text-body-large px-3 pb-3">
    {{ noItemsMessage }}
  </p>
}

<ng-template #scrollButton let-direction=direction let-visibilityProperty=visibilityProperty>
  <mx-fab [icon]="direction === 'REVERSE' ? 'keyboard_arrow_left' : 'keyboard_arrow_right'" [buttonClasses]="buttonClasses"
          [iconClasses]="`mat-icon-size-${buttonIconSize} ${buttonIconClasses}`" (click)="onClickButton(direction)"
          class="absolute z-10 self-center transition-opacity"
          [ngClass]="[
            direction === 'REVERSE' ? leftButtonOffsetClass : rightButtonOffsetClass,
            visibilityProperty ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
          ]"/>
</ng-template>
